import { API_BASE } from '../components/config';

export const resolveAvatarSource = avatarUrl => {
  if (!avatarUrl) return '';
  const value = String(avatarUrl).trim();
  if (!value) return '';
  try {
    const parsed = new URL(value);
    const hostname = parsed.hostname.toLowerCase();
    if (parsed.protocol === 'https:' && (hostname === 'line-scdn.net' || hostname.endsWith('.line-scdn.net'))) {
      return `${API_BASE}/api/avatar-proxy?url=${encodeURIComponent(value)}`;
    }
  } catch {
    // Relative upload path; resolve against the API origin below.
  }
  if (/^(https?:|data:|blob:)/i.test(value)) return value;
  return `${API_BASE}${value.startsWith('/') ? '' : '/'}${value}`;
};
